import backArrowIcon from '@icons/backArrow';
import closeIcon from '@icons/closeIcon';
import closeModalIcon from '@icons/closeModal';
import priceReducedIcon from '@icons/dynamic/priceReducedIcon';
import callForPriceCommunityIcon from '@icons/dynamic/callForPriceCommunityIcon';
import callForPriceCommunityActiveIcon from '@icons/dynamic/callForPriceCommunityActiveIcon';
import callForPriceHomeIcon from '@icons/dynamic/callForPriceHomeIcon';
import callForPriceHomeActiveIcon from '@icons/dynamic/callForPriceHomeActiveIcon';
import ratingStarIcon from '@icons/dynamic/ratingStarIcon';
import markerArrowIcon from '@icons/dynamic/triangle-marker';
import markerTipIcon from '@icons/dynamic/market-tip';
import markerArrowHoverIcon from '@icons/dynamic/triangle-marker-hover';
import closeSmallIcon from '@icons/dynamic/close-small-16';
import thanksContentIcon from '@icons/thanksContent';
import locationIcon from '@icons/dynamic/location';
import interactiveSitePlanIcon from '@icons/interactiveSitePlan.svg';
import visibilityOffIcon from '@icons/dynamic/visibilityOff.svg';
import visibilityIcon from '@icons/dynamic/visibility.svg';

// uTour modal icons
import utourZondaLogo from '@icons/utourZondaLogo';
import nhsLogo from '@icons/nhsLogo';
import checkIcon from '@icons/checkIcon';
import utourArrow from '@icons/utourArrow';
import creditCard from '@icons/creditCard';
import idCard from '@icons/idCard';
import jumioLogo from '@icons/jumioLogo';
import stripeLogo from '@icons/stripeLogo';

// progress bar icons
import progressCheckIcon from '@icons/progressCheckIcon';
import progressCurrentIcon from '@icons/progressCurrentIcon';
import progressEmptyIcon from '@icons/progressEmptyIcon';

// modal icons
import thankYouHeart from '@icons/modal/thankYouHeart';
import thankYouEmail from '@icons/modal/thankYouEmail';
import thankYouPhone from '@icons/modal/thankYouPhone';
import thankYouSuccess from '@icons/modal/thankYouSuccess';
import thankYouLoader from '@icons/modal/thankYouLoader';

// toast icons
import circleCheck from '@icons/circleCheck';
import circleWarning from '@icons/circleWarning';
import circleCheckIcon from '@icons/circleCheckIcon';

// these are static icons, webpack will return the path to the file instead of the icon itself
export const backArrowSvg = `<img src="${backArrowIcon}" />`;
export const closeIconSvg = `<img src="${closeIcon}" />`;
export const closeModalIconSvg = `<img src="${closeModalIcon}" />`;
export const thanksContentIconSvg = `<img class="builder__icon" src="${thanksContentIcon}" />`;
export const interactiveSitePlanSvg = `<img src="${interactiveSitePlanIcon}" />`;

export const thankYouHeartSvg = `<img src="${thankYouHeart}" />`;
export const thankYouEmailSvg = `<img src="${thankYouEmail}" />`;
export const thankYouPhoneSvg = `<img src="${thankYouPhone}" />`;
export const thankYouSuccessSvg = `<img class="builder__icon success__icon" height="100" src="${thankYouSuccess}" />`;
export const thankYouLoaderSvg = `<img class="brochure-download__spin-icon--spin" src="${thankYouLoader}" />`;

export const utourZondaLogoSvg = `<img src="${utourZondaLogo}" alt="uTour - Powered by Zonda" />`;
export const nhsLogoSvg = `<img src="${nhsLogo}" alt="New Home Source" />`;
export const checkIconSvg = `<img src="${checkIcon}" class="nhs-u-width--full" alt="Checkmark icon" />`;
export const utourArrowSvg = `<img src="${utourArrow}" alt="" />`;
export const creditCardSvg = `<img src="${creditCard}" alt="Credit card icon" />`;
export const idCardSvg = `<img src="${idCard}" alt="Identification icon" />`;
export const jumioLogoSvg = `<img src="${jumioLogo}" alt="Verified by jumio" />`;
export const stripeLogoSvg = `<img src="${stripeLogo}" alt="Verified by stripe" />`;

export const progressCheckIconSvg = `<img src="${progressCheckIcon}" class="nhs-c-progress-bar__svg" alt="Completed step" />`;
export const progressCurrentIconSvg = `<img src="${progressCurrentIcon}" class="nhs-c-progress-bar__svg" alt="Current step" />`;
export const progressEmptyIconSvg = `<img src="${progressEmptyIcon}" class="nhs-c-progress-bar__svg" alt="Future step" />`;

// These are dynamic icons, these are served as svg-in-js and are included in the .js bundle
// you should only consider using dynamic icons if you need to change the color or any other
// attribute of the icon itself.
export const callForPriceCommunityIconSvg = callForPriceCommunityIcon;
export const callForPriceCommunityActiveIconSvg =
  callForPriceCommunityActiveIcon;
export const callForPriceHomeIconSvg = callForPriceHomeIcon;
export const callForPriceHomeActiveIconSvg = callForPriceHomeActiveIcon;
export const priceReducedIconSvg = priceReducedIcon;
export const ratingStartIconSvg = ratingStarIcon;
export const locationIconSvg = locationIcon;
export const markerArrowIconSvg = markerArrowIcon;
export const markerTipIconSvg = markerTipIcon;
export const markerArrowHoverIconSvg = markerArrowHoverIcon;
export const closeSmallIconSvg = closeSmallIcon;
export const circleCheckIconSvg = circleCheckIcon;
export const visibilityOffIconSvg = visibilityOffIcon;
export const visibilityIconSvg = visibilityIcon;

export const circleCheckSvg = `<img src="${circleCheck}" />`;
export const circleWarningSvg = `<img src="${circleWarning}" />`;
